export default "__VITE_PUBLIC_ASSET__1e94cb59__"